export default __webpack_public_path__ + "static/media/NR.d52437be.jpg";